import React from 'react'

import { Editor } from '@tinymce/tinymce-react'

import withStyles from '@material-ui/core/styles/withStyles'

import Grid from '@material-ui/core/Grid'
import MenuList from '@material-ui/core/MenuList'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import CardActions from '@material-ui/core/CardActions'
import RadioGroup from '@material-ui/core/RadioGroup'
import Radio from '@material-ui/core/Radio'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import IconButton from '@material-ui/core/IconButton'

import PlaceIcon from '@material-ui/icons/Place'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import CanclelIcon from '@material-ui/icons/Cancel'
import DeleteIcon from '@material-ui/icons/Delete'
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera'
import AddCircleIcon from '@material-ui/icons/AddCircle'

import { EventMenuItems } from '../containers'
import { EventListCard } from '../containers'
import { TitleGrid, Word } from '../../../containers'
import AsyncContainer from '../../../containers/Common/AsyncContainer'

import { authorTypeItems, EVENT_REGISTER_RESULT } from '../../../constants'
import { event as limit } from '../../../constants/Limit'

import moment from 'moment'
import { WID } from '../../../constants/Language';
import { Auth0Context } from '../../../Parts/Auth0'
import { useContext } from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { SettingsContext } from '../../../Parts/Settings'
import { makePath } from '../../../lib'
import { useHistory } from 'react-router-dom'

const DatePicker = AsyncContainer(() => import(/* webpackChunkName: "DatePicker" */  '@maven-io/material-ui-pickers/DatePicker')
  .then(module => module.default), { name: 'DatePicker' });

const TimePicker = AsyncContainer(() => import(/* webpackChunkName: "TimePicker" */  '@maven-io/material-ui-pickers/TimePicker')
  .then(module => module.default), { name: 'TimePicker' });

const PlacesAutocomplete = AsyncContainer(() => import(/* webpackChunkName: "react-places-autocomplete" */  'react-places-autocomplete')
    .then(module => module.default), { name: 'PlacesAutocomplete' });

const styles2 = theme => ({
  dropdownBox: {
    color: theme.palette.grey[700]
  },
  textField: {
    marginTop: theme.spacing.unit * 2,
  }
})

class LocationSearchInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = { address: '' }
  }
 
  handleChange = address => {
    this.setState({ address })
  }
 
  handleSelect = address => {
    this.setState({ address })
    this.props.onChangeAddress(address)
    var reactPlacesAutocomplete
    import(/* webpackChunkName: "react-places-autocomplete" */  'react-places-autocomplete')
    .then(module => {
      reactPlacesAutocomplete = module
      return reactPlacesAutocomplete.geocodeByAddress(address)
    })
    .then(results => {
      this.props.onGeoCode(results[0])
      return reactPlacesAutocomplete.getLatLng(results[0])
    })
    .then(latLng => {
      this.props.onChangeLatLng(latLng)
    })
    .catch(error => console.error('Error', error))
  }
 
  render() {
    const { classes, googleMap } = this.props
    return googleMap.loaded === true ? (
      <PlacesAutocomplete
        value={this.state.address}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div>
            <TextField
              label={<Word wid={WID.EVENT_REGISTER_CARD.PLACE_LABEL}/>}
              {...getInputProps({})}
              fullWidth
              className={classes.textField}
            />
            <div className={classes.dropdownBox}>
              {loading && <Typography color='inherit'>Loading...</Typography>}
              {suggestions.map(suggestion => {
                const className = suggestion.active
                  ? 'suggestion-item--active'
                  : 'suggestion-item'
                // inline style for demonstration purpose
                const style = suggestion.active
                  ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                  : { backgroundColor: '#ffffff', cursor: 'pointer' }
                return (
                  <Typography
                    color='inherit'
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style,
                    })}
                  >
                    <span>{suggestion.description}</span>
                  </Typography>
                )
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    ) : (<React.Fragment></React.Fragment>)
  }
}

LocationSearchInput = withStyles(styles2, { withTheme: true })(LocationSearchInput)

const styles1 = theme => ({
  card: {
    margin: '0 auto',
    maxWidth: 680,
    width: '100%',
  },
  cardHeader: {
    marginTop: theme.spacing.unit,
    marginLeft: theme.spacing.unit,
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  itemName: {
    marginTop: theme.spacing.unit * 2,
    marginRight: 0,
    marginBottom: theme.spacing.unit * 2,
    marginLeft: 0,
    color: theme.palette.grey[700],
    whiteSpace: 'nowrap',
    width: 100,
    maxWidth: 100,
    minWidth: 100,
    boxSizing: 'border-box',
  },
  textFieldWide: {
    width: '100%',
    maxWidth: 416,
    marginRight: theme.spacing.unit * 2,
  },
  textField: {
    width: '100%',
    maxWidth: 150,
    marginRight: theme.spacing.unit * 2,
  },
  datetimePicker: {
    width: '100%',
    maxWidth: 150,
    marginTop: theme.spacing.unit,
    marginRight: theme.spacing.unit * 2,
  },
  centerBox: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  baselineBox: {
    display: 'flex',
    alignItems: 'baseline',
  },
  button: {
    margin: theme.spacing.unit / 2,
  },
  buttonIcon: {
    color: theme.palette.primary.main,
    marginRight: theme.spacing.unit,
  },
  formControlLabel: {
    marginLeft: theme.spacing.unit,
  },
  input: {
    display: 'none',
  },
  detailBox: {
    marginTop: theme.spacing.unit * 4,
  },
  errorText: {
    color: theme.palette.error.main,
  },
  addressBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing.unit,
    border: `1px solid ${theme.palette.grey[500]}`,
    margin: `${theme.spacing.unit * 2}px 0`,
    borderRadius: 10,
  },
  address: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    margin: theme.spacing.unit,
    color: theme.palette.grey[500],
  }
})

const EventRegisterCardComponent = (props) => {
  var styles, paddingWidth, data
  const { init, eventId, classes, theme, width, update, record, authorType, name, thumbnail, address, latitude, longitude, addressComponents, startDate, startTime, endDate, endTime, detail, checkedEndDatetime, error, disabledRegisterButton, handleChangedText, handleChangedDateTime, handleChangedLatLng, handleGeoCode, handleChangedTinyMCE, handleChangedCheckButton, handleChangedAddress, handleDeleteAddress, googleMap } = props

  const [listenerID, setListenerID] = useState()
  const [isInitialized, setIsInitialized] = useState(false)

  const auth0Context = useContext(Auth0Context)
  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  const history = useHistory()

  const handleChangeThumbnail = () => {
    var thumbnailUploadDom = document.getElementById('thumbnailUrl')
    if (thumbnailUploadDom) {
      thumbnailUploadDom.click()
    }
  }

  const handleDeleteThumbnail = () => {
    var thumbnailUploadDom = document.getElementById('thumbnailUrl')
    if (thumbnailUploadDom) {
      thumbnailUploadDom.value = ''
    }
    props.handleDeletePhoto('thumbnail')
  }

  const handleChange = (name) => (event) => {
    var reader = new FileReader()
    reader.onload = () => {
      props.handleChangePhoto(name, reader.result)
    }
    if (event.target.files[0]) {
      reader.readAsDataURL(event.target.files[0])
    }
  }

  const handleRegister = (data, checkedEndDatetime) => () => {
    props.handleRegister(data, checkedEndDatetime)
    .then(response => {
      if (response && response.result === EVENT_REGISTER_RESULT.SUCCESS) {
        history.push(makePath(`/event/${response.eventId}`, language))
      } 
    })
  }

  const handleUpdate = (before, after, checkedEndDatetime) => () => {
    props.handleUpdate(before, after, checkedEndDatetime)
    .then(response => {
      if (response && response.result === EVENT_REGISTER_RESULT.SUCCESS) {
        history.push(makePath(`/event/${response.eventId}`, language))
      } 
    })
  }

  paddingWidth = theme.spacing.unit * 6
  styles = {
    thumbnailBox: {
      width: width > (320 + paddingWidth) ? 320 : width - 64,
      height: width > (320 + paddingWidth) ? 180 : (width - 64) * 180 / 320,
      backgroundColor: theme.palette.grey[200],
      backgroundImage: `url(${thumbnail})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      marginBottom: theme.spacing.unit,
    },
    stringLength: {
      color: detail.length <= limit.stringLength.detail ? theme.palette.grey[500] : theme.palette.error.main,
      margin: `${theme.spacing.unit}px auto`,
    },
  }
  data = { authorType, name, thumbnail, address, latitude, longitude, addressComponents, startDate, startTime, endDate, endTime, detail }

  useEffect(() => {
    if (auth0Context.user) {
      init(eventId)
      setIsInitialized(true)
    }
    setListenerID(auth0Context.onAuthStateChanged(user => {
      if (user && !isInitialized) {
        init(eventId)
      }
    }))
    return () => {
      if (listenerID) {
        auth0Context.unregisterAuthStateChanged(listenerID)
      }
    }
  }, [])

  useEffect(() => {
    init(eventId)
  }, [eventId])

  return (
    <Card className={classes.card}>
      <CardHeader className={classes.cardHeader} title={update ? <Word wid={WID.EVENT_REGISTER_CARD.EDIT_TITLE}/> : <Word wid={WID.EVENT_REGISTER_CARD.REGISTER_TITLE}/>}/>
      <CardContent>
        <div>
          <div className={classes.centerBox}>
            <Typography className={classes.itemName}><Word wid={WID.EVENT_REGISTER_CARD.REGISTANT_TYPE_LABEL}/></Typography>
            <RadioGroup
              name="authorType"
              value={authorType}
              onChange={handleChangedText('authorType')}
              row
            >
              {authorTypeItems.map((item) => {
                return (
                  <FormControlLabel
                    key={item.value}
                    value={item.value}
                    control={<Radio color="primary"/>}
                    label={<Word wid={item.wid}/>}
                    disabled={update}
                    className={classes.formControlLabel}
                  />)
              })}
            </RadioGroup>
          </div>
          <div className={classes.centerBox}>
            <Typography className={classes.itemName}><Word wid={WID.EVENT_REGISTER_CARD.THUMBNAIL_LABEL}/></Typography>
            <Button variant='text' onClick={handleChangeThumbnail} className={classes.button}>
              <PhotoCameraIcon className={classes.buttonIcon}/>
              <Typography color='primary'><Word wid={WID.EVENT_REGISTER_CARD.REGISTER_THUMBNAIL}/></Typography>
            </Button>
            {thumbnail && (
              <Button variant='text' onClick={handleDeleteThumbnail} className={classes.button}>
                <DeleteIcon className={classes.buttonIcon}/>
                <Typography color='primary'><Word wid={WID.EVENT_REGISTER_CARD.DELETE_THUMBNAIL}/></Typography>
              </Button>
            )}
          </div>
          <div style={styles.thumbnailBox} onClick={handleChangeThumbnail}/>
          <input
            id='thumbnailUrl'
            type="file"
            name="thumbnail"
            accept="image/jpg, image/jpeg, image/png"
            onChange={handleChange('thumbnail')}
            className={classes.input}
          />
        </div>
        <div className={classes.baselineBox}>
          <div className={classes.centerBox}>
            <TextField
              label={<Word wid={WID.EVENT_REGISTER_CARD.EVENT_NAME}/>}
              value={name}
              onChange={handleChangedText('name')}
              helperText={`${name.length}/${limit.stringLength.name}`}
              className={classes.textFieldWide}
              margin='normal'
            />
          </div>
        </div>
        <LocationSearchInput
          onGeoCode={handleGeoCode}
          onChangeLatLng={handleChangedLatLng}
          onChangeAddress={handleChangedAddress}
          googleMap={googleMap}
        />
        {address && (
          <div className={classes.addressBox}>
            <Typography className={classes.address}><PlaceIcon className={classes.icon}/>{address}</Typography>
            <IconButton onClick={handleDeleteAddress}><CanclelIcon className={classes.icon}/></IconButton>
          </div>
        )}
        <div className={classes.baselineBox} style={{marginTop: theme.spacing.unit * 2}}>
          <div className={classes.centerBox}>
            <DatePicker
              variant='body1'
              value={startDate.valueOf()}
              maxDate={moment().add(1, 'years').format('YYYY-MM-DD')}
              TextFieldComponent={TextField}
              leftArrowIcon={<KeyboardArrowLeftIcon/>}
              rightArrowIcon={<KeyboardArrowRightIcon/>}
              onChange={handleChangedDateTime('startDate')}
              disablePast={true}
              labelFunc={(date) => { return date.format('YYYY/MM/DD (ddd)') }}
              className={classes.datetimePicker}
              label={<Word wid={WID.EVENT_REGISTER_CARD.START_DATE}/>}
            />
            <TimePicker
              variant='body1'
              value={startTime !== null ? startTime.valueOf() : null}
              TextFieldComponent={TextField}
              onChange={handleChangedDateTime('startTime')}
              clearable={true}
              className={classes.datetimePicker}
              label={<Word wid={WID.EVENT_REGISTER_CARD.START_TIME}/>}
            />
            {checkedEndDatetime === false && (
              <Button variant='text' color='primary' onClick={handleChangedCheckButton('checkedEndDatetime', true)}>
                <AddCircleIcon className={classes.buttonIcon}/>
                <Typography color='primary'>{<Word wid={WID.EVENT_REGISTER_CARD.ADD_END_DATETIME}/>}</Typography>
              </Button>
            )}
          </div>
        </div>
        {error.startDateTime && (
          <Typography className={classes.errorText}>{error.startDateTime}</Typography>
        )}
        {checkedEndDatetime === true && (
          <React.Fragment>
            <div className={classes.baselineBox} style={{marginTop: theme.spacing.unit * 2}}>
              <div className={classes.centerBox}>
                <DatePicker
                  variant='body1'
                  value={endDate !== null ? endDate.format() : null}
                  maxDate={moment().add(1, 'years').format('YYYY-MM-DD')}
                  TextFieldComponent={TextField}
                  leftArrowIcon={<KeyboardArrowLeftIcon/>}
                  rightArrowIcon={<KeyboardArrowRightIcon/>}
                  onChange={handleChangedDateTime('endDate')}
                  disablePast={true}
                  clearable={true}
                  labelFunc={(date) => {
                    return date !== null ? date.format('YYYY/MM/DD (ddd)') : ''
                  }}
                  className={classes.datetimePicker}
                  label={<Word wid={WID.EVENT_REGISTER_CARD.END_DATE}/>}
                />
                <TimePicker
                  variant='body1'
                  value={endTime !== null ? endTime.format() : null}
                  TextFieldComponent={TextField}
                  onChange={handleChangedDateTime('endTime')}
                  clearable={true}
                  className={classes.datetimePicker}
                  label={<Word wid={WID.EVENT_REGISTER_CARD.END_TIME}/>}
                />
                <Button variant='text' color='primary' onClick={handleChangedCheckButton('checkedEndDatetime', false)}>
                  <CanclelIcon className={classes.buttonIcon}/>
                  <Typography color='primary'>{<Word wid={WID.EVENT_REGISTER_CARD.DELETE_END_DATETIME}/>}</Typography>
                </Button>
              </div>
            </div>
            {error.endDateTime && (
              <Typography className={classes.errorText}>{error.endDateTime}</Typography>
            )}
          </React.Fragment>
        )}
        <div className={classes.detailBox}>
          <Typography className={classes.itemName}><Word wid={WID.EVENT_REGISTER_CARD.DETAIL_LABEL}/></Typography>
          <Editor
            apiKey="k1muhvxtlcxng632p2jp9t6qxkoyqo4lacipy79fjn06aa67"
            init={{ plugins: 'link table' }}
            value={detail}
            onEditorChange={handleChangedTinyMCE('detail')}
          />
          <Typography style={styles.stringLength}>{`Size : ${detail.length}/${limit.stringLength.detail}`}</Typography>
        </div>
      </CardContent>
      <CardActions className={classes.cardActions}>
        <Button
          variant='contained'
          color='primary'
          className={classes.button}
          onClick={update ? handleUpdate(record, data, checkedEndDatetime) : handleRegister(data, checkedEndDatetime)}
          disabled={disabledRegisterButton}
        >
          {update ? <Word wid={WID.EVENT_REGISTER_CARD.UPDATE_BUTTON_LABEL}/> : <Word wid={WID.EVENT_REGISTER_CARD.REGISTER_BUTTON_LABEL}/>}
        </Button>
      </CardActions>
    </Card>
  )
}

const EventRegisterCard = withStyles(styles1, { withTheme: true })(EventRegisterCardComponent)


const styles = theme => ({
})

class EventRegister extends React.Component {  
  render() {
    const { theme, width, eventRegisterCardSProps, eventRegisterCardDProps, googleMap, language } = this.props
    var gridProp, titleGridProp
    gridProp = width < theme.breakpoints.values.md ? { xs: 12 } : { xs: 6 }
    titleGridProp = width < theme.breakpoints.values.md ? { menuItems : (<EventMenuItems/>) } : undefined

    return (
      <div>
        <TitleGrid spacing={16} titleType='event' {...titleGridProp}>
          {width >= theme.breakpoints.values.md && (
            <Grid item md={3}>
              <MenuList>
                <EventMenuItems/>
              </MenuList>
            </Grid>
          )}
          <Grid item {...gridProp}>
            <EventRegisterCard {...eventRegisterCardSProps} {...eventRegisterCardDProps} googleMap={googleMap} language={language}/>
          </Grid>
          <Grid item md={3} xs={12}>
            <EventListCard fullWidth/>
          </Grid>
        </TitleGrid>
      </div>
    )
  }
}


export default withStyles(styles, { withTheme: true })(EventRegister)



// WEBPACK FOOTER //
// ./src/Pages/Event/components/EventRegister.js